export const styleEditStation = {
    mainDiv: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        alignItems: "center",
        marginTop: 20
    },
    slotsTable: {
        width: "90vw"
    },
    mapStyle: {
        width: "90vw",
        height: 800,
        borderRadius: 10,
        marginTop: 10
    }
}

export const stylesLogin = {
    mainDiv: {
        display: "flex",
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
        marginTop: 30,
        height: "40v",
        width: "90%",
        justifyContent: "center",
        boxShadow: "1px 1px 2px #cbcbcb",
        marginLeft:"5%",
        padding: 0

    },
    form: {
        padding: 12
    },
    button: {
        width: "100%",
        borderRadius: 30,
        backgroundColor: 'white',
        color: '#096dd9'
    },
    InputRadius: {
        borderRadius: "2px!important"
    }
}

export const styleShowStation = {
    mainDiv: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 20
    },
    infoDiv: {
        display: "flex",
        flex: 1,
        width: "90vw",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center"
    }
}